import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from 'react-redux';
import axiosInstance from '../../utils/axiosInstanse';
import { clearNotification } from '../../reduser/notificationSlice';
import PassArchive from './PassArchive';
import { motion } from 'framer-motion';
import Button from '../CustomButton/Button';
import host from "../../host";
import CustomInput from '../Substitution/CustomPickDate';
import Spiner from '../Spiner/Spiner';
import useIsMobile from '../../utils/useIsMobile';
import { showNotification } from '../../utils/notificationUtils';
import './pass_activate.css';

registerLocale('ru', ru);

function MyComponent() {
  const [user, setUser] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [date, setdate] = useState(new Date());
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [page, setPage] = useState(1);
  const username = useSelector(state => state.user.username);
  const dispatch = useDispatch();
  const notification = useSelector(state => state.notification);
  const isMobile = useIsMobile(768);
  const [isError, setIsError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get(`${host}api/pass_activate/`)
      .then(response => {
        setIsLoading(false);
      })
      .catch(error => {
        if (error.response?.status === 403) {
          setIsError(true);
        }
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;
      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);
        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);

  const formatDate = (data) => {
    const date = new Date(data);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (sending) return;
    if (validateForm()) {
      const data = {
        date_from: formatDate(startDate),
        date_until: formatDate(date),
        user: user,
      };
      setSending(true);
      try {
        const response = await axiosInstance.post(`${host}api/pass_activate/`, data);
        if (response.status === 201) {
          setSending(false);
          showNotification(dispatch, 'Запись добавлена!', 'success');
          setPage(2);
        }
      } catch (err) {
        setSending(false);
        if (err.response?.status === 404) {
          showNotification(dispatch, 'Неверный табельный номер', 'error');
        } else if (err.response?.status === 400) {
          showNotification(dispatch, 'Ошибка валидации', 'error');
        } else {
          showNotification(dispatch, 'Ошибка отправки формы', 'error');
        }
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!startDate) newErrors.startDate = 'Дата начала обязательна';
    if (!date) newErrors.date = 'Дата окончания обязательна';
    if (!user) {
      newErrors.user = 'Введите табельный номер';
    } else if (user.length !== 5) {
      newErrors.user = 'Табельный номер должен содержать 5 цифр';
    } else if (!/^\d+$/.test(user)) {
      newErrors.user = 'Табельный номер должен содержать только цифры';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="pa-container">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.12 }}
      >
        {isLoading ? (
          <Spiner />
        ) : isError ? (
          <div className="pa-access-denied">У вас нет прав для доступа к данному разделу</div>
        ) : (
          <div>
            {/* Tabs */}
            <div className="pa-tabs">
              <button
                className={`pa-tab ${page === 1 ? 'pa-tab--active' : ''}`}
                onClick={() => setPage(1)}
              >
                Новая заявка
              </button>
              <button
                className={`pa-tab ${page === 2 ? 'pa-tab--active' : ''}`}
                onClick={() => setPage(2)}
              >
                Архив
              </button>
            </div>

            {page === 1 ? (
              <div className="pa-card">
                <div className="pa-card-body">
                  <div className="pa-warning">
                    <div className="pa-warning-title">ТОЛЬКО ДЛЯ РУКОВОДИТЕЛЕЙ!</div>
                    <div className="pa-warning-text">
                      Для оформления заявки на активацию пропуска сотруднику, вам необходимо указать дату начала и дату окончания периода, а также табельный номер сотрудника.
                    </div>
                  </div>

                  <div className="pa-current-user">Табельный номер: {username}</div>

                  <form onSubmit={handleSubmit}>
                    <div className="pa-date-row">
                      <div className="pa-field">
                        <label className="pa-label">Дата активации:</label>
                        <DatePicker
                          locale="ru"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd.MM.yyyy"
                          popperPlacement="top"
                          customInput={isMobile ? <CustomInput /> : undefined}
                          withPortal
                        />
                      </div>
                      <div className="pa-field">
                        <label className="pa-label">Дата деактивации:</label>
                        <DatePicker
                          locale="ru"
                          selected={date}
                          onChange={(date) => setdate(date)}
                          dateFormat="dd.MM.yyyy"
                          popperPlacement="top"
                          customInput={isMobile ? <CustomInput /> : undefined}
                          withPortal
                        />
                      </div>
                    </div>

                    <div className="pa-field">
                      <label className="pa-label" htmlFor="paUser">Табельный номер сотрудника</label>
                      <textarea
                        id="paUser"
                        className={`pa-input ${errors.user ? 'pa-input--error' : ''}`}
                        placeholder="Введите табельный номер сотрудника"
                        value={user}
                        onChange={e => setUser(e.target.value)}
                      />
                      {errors.user && <div className="pa-error">⚠ {errors.user}</div>}
                    </div>

                    <div className="pa-submit-wrap">
                      {sending ? (
                        <Button type="submit" disabled>
                          <span className="do-spinner" />
                        </Button>
                      ) : (
                        <Button type="submit">Отправить</Button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              <PassArchive />
            )}
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default MyComponent;